import { PaymentAccount } from "./payment-account.model";
import { PaymentCountry } from "./payment-country.model";
import { PaymentPlanDeclaration } from "./payment-plan-declaration.model";

export class PaymentPlanDetails {
    constructor() {
        this.totalOutstanding = 0;
        this.accounts = [];
        this.countries = [];
        this.declarations = [];
    }

    totalOutstanding: number;
    accounts: Array<PaymentAccount>;
    countries: Array<PaymentCountry>;
    declarations: Array<PaymentPlanDeclaration>;
    defaultFrequency?: string;
    defaultInstAmt?: number;
    defaultCountryId?: string;
    minStartDate?: string;
}
